import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-hidden"]
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "modal-footer" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "form-error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal-container modal-container-tfa-disable", { hidden: !_ctx.display }]),
    tabindex: "-1",
    role: "dialog",
    "aria-hidden": !_ctx.display,
    onKeydown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.escapeToClose && _ctx.escapeToClose(...args)))
  }, [
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
      class: "modal-dialog modal-md",
      role: "document",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.stopPropagationEvent && _ctx.stopPropagationEvent(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("Disable two factor authentication")), 1),
        _createElementVNode("button", {
          type: "button",
          class: "modal-close-btn",
          title: _ctx.$t('Close'),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, _hoisted_6, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", null, _toDisplayString(_ctx.$t("Input your one-time password")) + ":", 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "tfa-token",
            autocomplete: "off",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.token) = $event)),
            disabled: _ctx.busy,
            maxlength: "255",
            class: "form-control form-control-full-width auto-focus"
          }, null, 8, _hoisted_9), [
            [_vModelText, _ctx.token]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            type: "submit",
            disabled: _ctx.busy,
            class: "btn btn-primary"
          }, _toDisplayString(_ctx.$t("Disable two factor authentication")), 9, _hoisted_12)
        ]),
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.error), 1)
      ])
    ], 32)
  ], 42, _hoisted_1))
}